<template>
  <div>
    <br />
    <h2>Análisis de los resultados GUIATS</h2>
    <br />
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Aspecto</th>
            <th class="text-left">Rango</th>
            <th class="text-left">Diagnóstico</th>
            <th class="text-left">Recomendaciones</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="'aspect_'+aspect.idAspect" v-for="aspect in table">
            <td class="text-left">{{aspect.title}}</td>
            <td class="text-left">{{aspect.range.rango}}</td>
            <td class="text-left">{{aspect.range.diagnosis}}</td>
            <td class="text-left">{{aspect.range.recommendation}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      host: process.env.VUE_APP_HOST,
      aspects: [],
      questionnaire: []
    };
  },
  computed: {
    table() {
      if (this.aspects.length && this.questionnaire.length) {
        return this.aspects.map(aspect => {
          let answers = this.questionnaire.filter(
            reactive => aspect.idAspect == reactive.idAspect && reactive.answer
          );
          aspect.answers = answers.length;
          aspect.range = aspect.rangos.find(
            range =>
              answers.length >= range.minRango &&
              answers.length <= range.maxRango
          );
          aspect.rangos = [];
          return aspect;
        });
      }
    }
  },
  methods: {
    getQuestionnaire() {
      var vm = this;
      let data = {
        idParticipant: this.$route.params.participantId
      };

      axios
        .post(this.host + "/questionnaire/read.php", this.createFormData(data))
        .then(response => {
          vm.questionnaire = response.data.questionnaire;
        })
        .catch(error => {
          this.snackbar = true;
          this.message = "error";
        });
    },
    getAspects() {
      var vm = this;

      axios
        .get(this.host + "/aspects/read.php")
        .then(response => {
          vm.aspects = response.data.data;
        })
        .catch(error => {
          this.snackbar = true;
          this.message = "error";
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  created() {
    this.getAspects();
    this.getQuestionnaire();
  }
};
</script>

<style>
</style>